import React from 'react';
import cx from 'classnames';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import LoginLogout from './LoginLogout';

function Footer({ className }) {
  return (
    <section
      id="mk-footer"
      className=" mk-footer-disable"
      role="contentinfo"
      itemScope="itemscope"
      itemType="https://schema.org/WPFooter"
    >
      <div id="sub-footer" className="sub-footer-style-2">
        <div className="add-bs">
          {/* <div className="container-fluid"> */}
          <div className="container bigger">
            <div className="row">
              <div className="col-12 text-center text-md-left">
                <div className="row justify-content-between b-30">
                  <div className="col-md-auto d-flex b30 footer-col-1">
                    <a href="/">
                      <img
                        src="https://go.cynet.com/hubfs/Cynet%20Docs%20Files/Cynet_Logo_White.svg"
                        alt="cynet logo"
                        width="118"
                        height="29"
                        loading="lazy"
                      />
                    </a>

                    <p>Copyright © {new Date().getFullYear()} Cynet Security Ltd. All rights reserved. </p>
                  </div>
                  <div className="col-md-auto b30">
                    <div className="row align-items-center justify-content-center b-10">
                      <div className="col-auto b12 contact-us">
                        <a
                          href="https://www.cynet.com/contact-us/"
                        >
                          Contact Us
                        </a>
                      </div>
                      <div className="col-auto">
                        <div className="subfooter-social">
                          <ul>
                            <li>
                              <a
                                href="https://www.linkedin.com/company/cynet-security"
                                target="_blank"
                              >
                                <img src="https://go.cynet.com/hubfs/Cynet%20Docs%20Files/icon-linkedin.svg" alt="LinkedIn" />
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://twitter.com/cynet360"
                                target="_blank"
                              >
                                <img src="https://go.cynet.com/hubfs/Cynet%20Docs%20Files/icon-x.svg" alt="X" />
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.youtube.com/c/Cynet360"
                                target="_blank"
                              >
                                <img src="https://go.cynet.com/hubfs/Cynet%20Docs%20Files/icon-youtube.svg" alt="YouTube" />
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.facebook.com/cynet360/"
                                target="_blank"
                              >
                                <img src="https://go.cynet.com/hubfs/Cynet%20Docs%20Files/icon-facebook.svg" alt="Facebook" />
                              </a>
                            </li>
                     
                            
                            
                          </ul>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="clearboth" />
      </div>
    </section>
  );
}

export default Footer;
